<template>
  <div id="top-bar">
    <div v-if="topBarType === 'default'" class="default-top-bar">
      <h1 class="page-title">{{ pageTitle }}</h1>
      <VasionInput
        v-model="inputValue"
        class="search-input-field"
        placeholder="Search Vasion"
        inputType="search-gray"
        :readonly="!isGlobalSearchEnabled"
        :isSearch="true"
        :arrowValue="isSavedSearchOpen"
        :arrowClickCallback="toggleSavedSearchDisplay"
        @keyup.enter="runGlobalSearch"
        @click="handleSearchClick"
      />
      <div class="search-icon-btn">
        <VasionSearchIcon @click="openSearcherFromIcon" />
      </div>
      <div v-if="isSavedSearchOpen" class="vasion-search">
        <div class="vasion-search-overlay" @click="toggleSavedSearchDisplay" />
        <SavedSearchDropDown width="525" />
      </div>
    </div>
  </div>
</template>

<script>
import SavedSearchDropDown from "@/components/search/SavedSearchDropDown.vue";

export default {
  name: "TopBar",
  props: {},
  components: {
    SavedSearchDropDown,
  },
  data: function () {
    return {
      globalSearchID: 0,
      inputValue: "",
      isSearchVisible: false,
      topBarType: "default",
    };
  },
  computed: {
    activeSubApp() {
      return this.$store.state.mainViews.activeSubApp.toUpperCase();
    },
    isGlobalSearchEnabled() {
      return this.$store.state.search.isGlobalSearchEnabled;
    },
    isSavedSearchOpen() {
      return this.$store.state.mainViews.isSavedSearchOpen;
    },
    isVasionHome() {
      return this.$store.state.mainViews.vasionHomeToggle;
    },
    pageTitle() {
      return !this.isVasionHome && this.activeSubApp !== ""
        ? this.activeSubApp
        : "Welcome to Automate Pro";
    },
  },
  async created() {
    await this.$store.dispatch('search/getGlobalSearchEnabled')
  },
  methods: {
    handleSearchClick() {
      if (this.isGlobalSearchEnabled) return;
      this.toggleSavedSearchDisplay();
    },
    openSearcherFromIcon() {
      this.$store.dispatch("mainViews/toggleSavedSearchDropDown", !this.isSavedSearchOpen);
    },
    async runGlobalSearch() {
      if (this.inputValue === "") {
        return;
      }
      this.$amplitude.trackEvent("Search Run", { searchType: "Global" });
      this.globalSearchID = await this.$store.dispatch("search/getGlobalSearchID");
      const payload = {
        SearchId: this.globalSearchID,
        SearchType: 161,
        FullText: this.inputValue,
      };
      await Promise.all([
        this.$store.dispatch("search/setSelectedSearch", {
          SearchId: this.globalSearchID,
          Type: 161,
          isGlobalSearch: true,
        }),
        this.$store.dispatch("search/setSearchCriteria", payload),
      ]);
      this.$router.push({ name: "SearchResults" }).catch(() => {});
    },
    toggleSavedSearchDisplay() {
      this.$store.dispatch("mainViews/toggleSavedSearchDropDown", !this.isSavedSearchOpen);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
@import "@/assets/css/light-theme-system-palette.scss";
@import "@/assets/css/vuetify3Breakpoints.scss";

#top-bar {
  width: 100%;
}
.default-top-bar {
  display: flex;
  height: 64px;
  width: calc(100vw - 72px);
  align-items: justify;
  position: absolute;
  top: 0;
  z-index: 1100;
  right: 12px;
  left: 72px;

  @include breakpoint(sm) {
    height: 48px;
    width: 100%;
    right: 0;
    left: 48px;
    position: unset;
    z-index: 1000;
  }
}
.page-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
  align-self: stretch;
  overflow: hidden;
  color: $on-primary;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: $font-family-book;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-transform: capitalize;
  margin: unset;

  @include breakpoint(sm) {
    color: $primary;
    font-family: $font-family-accent;
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
  }

  @include breakpoint(md) {
    font-size: 20px;
    line-height: 24px;
  }
}
.search-input-field {
  display: none;

  @include breakpoint(md) {
    display: block;
    width: 260px;
    height: 40px;
    align-self: center;
  }

  @include breakpoint(lg) {
    width: 320px;
  }
}
.search-icon-btn {
  width: 48px;
  display: block;
  align-self: center;
  fill: $on-primary;
  text-align: center;

  @include breakpoint(sm) {
    fill: $primary;
    text-align: end;
  }

  @include breakpoint(md) {
    display: none;
  }
}
.vasion-search-overlay {
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 3;
  cursor: pointer;
}
</style>
